"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockRemoteContent = exports.blockRemoteContentCheerio = void 0;
var cheerio_1 = __importDefault(require("cheerio"));
var blockRemoteContentInAttributes_1 = __importDefault(require("./blockRemoteContentInAttributes"));
var blockRemoteContentInStyle_1 = __importDefault(require("./blockRemoteContentInStyle"));
// This is a 1x100 transparent PNG used to replace images
// Generated using http://png-pixel.com/
// Note: using a 1x1 square results in large square empty
//       spaces in many e-mails, because only the width is
//       defined in the HTML; and the height gets scaled
//       proportionally. Thus the 1x100 ratio instead
// https://github.com/mailpile/Mailpile/blob/babc3e5c3e7dfa3326998d1628ffad5b0bbd27f5/shared-data/default-theme/html/jsapi/message/html-sandbox.js#L43-L47
var TRANSPARENT_1X100_URL = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
/**
 * Replace all URLs that could be automatically fetched when displaying the HTML. These can be used for tracking, or can consume bandwidth.
 */
function blockRemoteContentCheerio($, replacements) {
    if (replacements === void 0) { replacements = {}; }
    var _a = replacements.image, image = _a === void 0 ? TRANSPARENT_1X100_URL : _a, _b = replacements.other, other = _b === void 0 ? '#' : _b;
    // Block remote URLs in style tags
    blockRemoteContentInStyle_1.default($, image);
    // Block remote URLs in tags attributes
    blockRemoteContentInAttributes_1.default($, { image: image, other: other });
}
exports.blockRemoteContentCheerio = blockRemoteContentCheerio;
/**
 * Same as blockRemoteContentCheerio, but to be used as a standalone.
 */
function blockRemoteContent(html, replacements) {
    if (replacements === void 0) { replacements = {}; }
    var $ = cheerio_1.default.load(html);
    blockRemoteContentCheerio($, replacements);
    return $.html();
}
exports.blockRemoteContent = blockRemoteContent;
